"use client"
import { createContext, useContext } from "react"

// True on surfaces where hover is not a real input (the mobile dashboard:
// touch taps synthesize enter events and were driving the desktop hover
// swaps). Every hover-swap PROVIDER reads this and provides null instead of
// its live value — consumers are already null-safe (they render their base,
// unhovered content without a provider), so the whole hover system goes
// inert in one place. Desktop never provides this; default false.
export const HoverSwapsDisabledContext = createContext(false)

export const useHoverSwapsDisabled = () => useContext(HoverSwapsDisabledContext)
